import "../CSS/header.css";

export const HeaderBottom = () => {
  return (
    <>
    <div className="headerBottom">
        <h2>La mia bacheca</h2>
    </div>
    </>
  );
};
